import Vue from 'vue'

Vue.filter('OrderState', (value) => {
  const map = {
    needConfirmation: '待确认',
    notSent: '未发货',
    partlySent: '部分发货',
    allSent: '全部发货',
    completed: '已完成',
    cancelled: '已取消',
    draft: '草稿',
    confirmed: '等待库存可用',
    reserved: '准备发货',
    shipped: '已发货',
    finished: '完成',
    receiving: '待收货',
    sending: '待发货',
    review: '待复核',
    repairing: '维修中',
    qc: '待质检',
  }
  return map[value]
})

Vue.filter('RepairType', (value) => {
  const map = {
    rental: '租赁维修',
    external: '外部维修',
    delegated: '委托维修',
    managed: '代管维修',
    parts: '拆件维修',
    custom: '自建维修',
    null: '-',
  }
  return map[value] || value
})

Vue.filter('InventorySource', (value) => {
  const map = {
    rent: '代管库',
    delegate: '委托库',
    manage: '自己委托库',
    null: '-',
  }
  return map[value] || value
})

Vue.filter('DelegationType', (value) => {
  const map = {
    rent: '只租',
    sales: '只售',
    rent_sales: '可租可售',
    managed: '代管',
  }
  return map[value] || value
})

// 网点类型
Vue.filter('PosType', (value) => {
  const map = {
    1: '在行无人银行',
    2: '离行无人银行',
    3: '网点营业厅',
  }
  return map[value] || value
})
// 设备类型
Vue.filter('PosDeviceType', (value) => {
  const map = {
    1: '现金自助设备',
    2: '非现金自助设备',
  }
  return map[value] || value
})

Vue.filter('EntrustType', (value) => {
  const map = {
    1: '只租',
    2: '只售',
    3: '可租可售',
    4: '代管',
    null: '-',
  }
  return map[value] || value
})

Vue.filter('EntrustState', (value) => {
  const map = {
    1: '受托方待收货',
    2: '受托方处理中',
    3: '已完成',
    null: '-',
  }
  return map[value] || value
})

Vue.filter('ConditionColor', (value) => {
  const map = {
    原装全新: 'primary',
    原装九五成新: 'primary',
    原装九成新: 'primary',
    原装二手: 'primary',
    国产全新A: 'success',
    国产全新B: 'success',
    国产全新C: 'success',
    国产二手: 'success',
    原装全新改装: 'primary',
    原装九成新改装: 'primary',
    原装二手改装: 'primary',
    国产全新改装: 'success',
    国产二手改装: 'success',
  }
  return map[value] || value
})

Vue.filter('RentalOrderOrderType', (value) => {
  const map = {
    flexibleTerm: '灵活租期',
    inflexibleTerm: '固定租期',
  }
  return map[value] || value
})

Vue.filter('ProcurementType', (value) => {
  const map = {
    one_to_one: '一对一',
    one_to_many: '一对多',
    many_to_one: '多对一',
  }
  return map[value]
})

Vue.filter('DispatchState', (value) => {
  const map = {
    confirmed: '待确认',
    finished: '完成调度',
    shipped: '调度中',
    cancelled: '已取消',
  }
  return map[value]
})

Vue.filter('OrderSource', (value) => {
  const map = {
    order: '调度申请单',
    InStockPicking: '入库单',
    RentalOrder: '租赁单',
    OutStockPicking: '发货单',
    InternalStockPicking: '内部调拨单',
    DeliveryOrder: '物流单',
    DeliveryPartsRepairRequest: '拆件维修单',
    DeliveryBackupReturn: '备用件退货单',
    QcOrder: '质检单',
    RentalReturnOrder: '租赁退货单',
    RentalExchangeOrder: '租赁换货单',
    RentalRepairOrder: '租赁维修单',
    InventoryOrder: '盘点单',
    external: '外部维修',
    managed: '代管维修',
    parts: '拆件维修',
    delegated: '委托维修',
    RepairOrder: '维修订单',
    RepairWorkOrder: '维修单',
    ExternalRepairWorkOrder: '委外维修单',
    null: '自建',
  }
  return map[value] || value
})

Vue.filter('ServiceState', (value) => {
  const map = {
    draft: '待确认',
    receiving: '待收货',
    finished: '已完成',
    cancelled: '已取消',
    repairing: '维修中',
    qc: '待质检',
    review: '待复核',
    null: '-',
  }
  return map[value] || value
})

Vue.filter('DispatchOrderState', (value) => {
  const map = {
    created: '待确认',
    confirmed: '待审核',
    rechecked: '已复核',
    verified: '待发货',
    shipped: '已完成',
    cancelled: '已取消',
    null: '-',
  }
  return map[value] || value
})

Vue.filter('RentalOrderState', (value) => {
  const map = {
    needConfirmation: '待确认',
    notSent: '未发货',
    partlySent: '部分发货',
    expired: '已到期',
    allSent: '全部发货',
    normal: '租赁中',
    completed: '已完成',
    cancelled: '已取消',
  }
  return map[value] || value
})

Vue.filter('StockTransferState', (value) => {
  const map = {
    draft: '草稿',
    confirmed: '等待库存可用',
    reserved: '准备发货',
    shipped: '已发货',
    finished: '完成',
    cancelled: '取消',
  }
  return map[value]
})

Vue.filter('RepairState', (value) => {
  const map = {
    waitting: '等待维修处理',
    instock: '入库',
    sendBack: '寄回',
    scrap: '报废',
    external: '委外维修',
    repair: '内部维修',
  }
  return map[value]
})

Vue.filter('RentalOrderDeliveryType', (value) => {
  const map = {
    delegateDelivery: '租赁代发',
    immediateDelivery: '即时发货',
  }
  return map[value]
})

Vue.filter('NullShow', (value) => {
  const map = {
    null: '-',
  }
  return map[value] || value
})

Vue.filter('NullShowCN', (value) => {
  const map = {
    '': '未确认',
    null: '未确认',
  }
  return map[value] || value
})

/* 委托租赁分成 */
Vue.filter('Scale', (value) => {
  return value / 10 + ':' + (10 - (value / 10))
})

Vue.filter('LogisticsSource', (value) => {
  const map = {
    InStockPicking: '入库单',
    RentalOrder: '租赁订单',
    OutStockPicking: '发货单',
    DeliveryBackupReturn: '备用件退货单',
    InternalStockPicking: '内部调拨单',
    LogisticsOrder: '物流单',
    QcOrder: '质检单',
    RentalReturnOrder: '租赁退货单',
    RentalExchangeOrder: '租赁换货单',
    RentalRepairOrder: '租赁维修单',
    InventoryOrder: '盘点单',
    RepairOrder: '维修订单',
    RepairWorkOrder: '维修单',
    ExternalRepairWorkOrder: '委外维修单',
    null: '自建物流单',
  }
  return map[value] || value
})

Vue.filter('ChangeDeliveryType', (value) => {
  const map = {
    immediately: '即时发货',
    scheduled: '预约发货',
  }
  return map[value]
})

Vue.filter('TrueFalse', (value) => {
  const map = {
    true: '是',
    false: '否',
  }
  return map[value] || value
})

Vue.filter('LogisticsState', (value) => {
  const map = {
    draft: '待发货',
    confirmed: '待发货',
    shipped: '配送中',
    arrived: '配送完成',
    finished: '配送完成',
    cancelled: '配送取消',
  }
  return map[value]
})

Vue.filter('NormalState', (value) => {
  const map = {
    draft: '待确认',
    confirmed: '已确认',
    cancelled: '已取消',
  }
  return map[value]
})

Vue.filter('RentalOrderOrderType', (value) => {
  const map = {
    flexibleTerm: '灵活租期',
    inflexibleTerm: '固定租期',
  }
  return map[value]
})

Vue.filter('ShipmentMethod', (value) => {
  const map = {
    internal: '森普瑞物流',
    external: '第三方物流',
    none: '自提',
  }
  return map[value]
})

Vue.filter('OriginalOrderType', (value) => {
  const map = {
    order: '调度申请单',
    RentalOrder: '租赁单',
    InStockPicking: '收货单',
    OutStockPicking: '发货单',
    StorageStockPicking: '入库单',
    InternalStockPicking: '内部调拨单',
    DeliveryOrder: '物流单',
    QcOrder: '质检单',
    RentalReturnOrder: '租赁退货单',
    RentalExchangeOrder: '租赁换货单',
    RentalRepairOrder: '租赁维修单',
    InventoryOrder: '盘点单',
    RepairOrder: '维修订单',
    RepairWorkOrder: '维修单',
    ExternalRepairWorkOrder: '委外维修单',
    DeliveryBackupReturn: '备件退货单',
    DeliveryPartsRepairRequest: '拆机件维修单',
  }
  return map[value] || value
})

Vue.filter('date', (value, format) => {
  if (!value) return
  return Vue.$moment(value).format(format)
})

Vue.filter('Warranty', (value, WarrantyMonths) => {
  if (!value) return
  const date = Vue.$moment(value)
  const now = Vue.$moment()
  let months
  let days
  let result = ''
  if (WarrantyMonths) {
    date.add(WarrantyMonths, 'M')
  }
  months = date.diff(now, 'M')
  if (months < 0) {
    return '过保'
  } else {
    date.subtract(months, 'M')
    days = date.diff(now, 'd')
  }
  result += months > 0 ? months + '个月' : ''
  result += days > 0 ? days + '天' : ''
  if (!result) result = '0天'
  return result
})

Vue.filter('fromNow', (value) => {
  if (!value) return
  const date = Vue.$moment(value)
  const now = Vue.$moment()
  let months
  let days
  let result = ''
  months = now.diff(date, 'M')
  if (months > 0) {
    now.subtract(months, 'M')
    days = now.diff(date, 'd')
  }
  result += months > 0 ? months + '个月' : ''
  result += days > 0 ? days + '天' : ''
  if (!result) result = '0天'
  return result
})

Vue.filter('amount', (value) => {
  const defaltVal = '￥0.00'
  if (!value) return defaltVal
  const newVal = parseFloat(value)
  if (Number.isNaN(newVal)) return defaltVal
  return '￥' + newVal.toFixed(2)
})

// 权限
Vue.filter('Permissions', (value) => {
  const map = {
    '/': '首页',
    '/entrust': '委托管理',
    '/lease': '租赁管理',
    '/repair': '维修管理',
    '/inventory': '库存管理',
    '/logistics': '物流管理',
    '/order': '订单管理',
    '/financial': '结算查询',
    '/profile/info': '个人中心',
  }
  return map[value]
})

// 维修订单批次维修结果
Vue.filter('RepairLotResult', (value) => {
  const map = {
    fixed: '已修复',
    notFixed: '未修复',
  }
  return map[value] || value || '-'
})

// 空日期
Vue.filter('NullDate', (value) => {
  const map = {
    '1753-01-01': '租赁未结束',
  }
  return map[value] || value || '-'
})



// WEBPACK FOOTER //
// ./src/filters.js